import type { CalendarEventReminderInfoForType } from "@tellescope/types-models";
import { Checkbox, Label } from "@tellescope/ui";
import { useTranslation } from "react-i18next";

type WebhookReminder = CalendarEventReminderInfoForType["webhook"];

export interface WebhookInfoSectionProps {
  value: WebhookReminder;
  onChange: (newValue: WebhookReminder) => void;
}

export const WebhookInfoSection = ({ value, onChange }: WebhookInfoSectionProps) => {
  const { t } = useTranslation("calendar");

  return (
    <span className="flex gap-2 items-center">
      <Checkbox
        id="webhook-send-even-if-passed"
        checked={!value.dontSendIfPassed}
        onCheckedChange={(checked) =>
          onChange({
            ...value,
            dontSendIfPassed: !checked,
          })
        }
      />
      <Label htmlFor="webhook-send-even-if-passed" className="text-muted-foreground text-xs font-light">
        {t("Send even if timing has passed")}
      </Label>
    </span>
  );
};
